/**
 * Footer labels
 */

import svFooter from '../locales/sv/footer.json';
import enFooter from '../locales/en/footer.json';
import { getLanguage, type Language } from '@/utils/languageUtils';

const getFooterLocale = (lang?: Language) => {
  const currentLang = lang || getLanguage();
  return currentLang === 'en' ? enFooter : svFooter;
};

export const footerLabels = (lang?: Language) => getFooterLocale(lang);
